export default __webpack_public_path__ + "static/media/sport_badges_preview.2446db36.png";